import request from '../utils/axios'

const devUrl = 'http://192.168.1.17:8081/kana'
const proUrl = 'http://139.199.65.131:8080/kana/'
const dev = false
export const baseUrl = dev ? devUrl : proUrl

export function formatData (payload) {
  const formData = new FormData()
  for (const key in payload) {
    if (payload.hasOwnProperty(key)) {
      formData.append(key, payload[key])
    }
  }
  return formData
}

// 查询产品目录
export function catalog () {
  return request(`${baseUrl}/front/catalogs/getAllFirstCatalogs`, {
    method: 'POST'
    // body: formatData(payload)
  })
}
// 查询产品
export function product (payload) {
  return request(`${baseUrl}/front/catalogs/getSecondCatalogs`, {
    method: 'POST',
    data: formatData(payload)
  })
}
// 查询新闻列表
export function newsList () {
  return request(`${baseUrl}/front/news/getAllNews`, {
    method: 'POST'
  })
}
// 展示新闻内容
export function newsCon (payload) {
  return request(`${baseUrl}/back/news/findNewsById`, {
    method: 'POST',
    data: formatData(payload)
  })
}
// 查询产品
export function consult (payload) {
  return request(`${baseUrl}/front/consult/addConsult`, {
    method: 'POST',
    data: formatData(payload)
  })
}
// 搜索产品
export function search (payload) {
  return request(`${baseUrl}/front/catalogs/getLikeCatalogs`, {
    method: 'POST',
    data: formatData(payload)
  })
}
// 添加新闻

export function addNews (payload) {
  return request(`${baseUrl}/back/news/addNews`, {
    method: 'POST',
    data: formatData(payload)
  })
}

// 搜索库存
export function stock (data) {
  return request(`http://106.14.13.51:2388/StockSearch/Search`, {
    // return request(`http://np-culture.org/sms/stock.php`, {
    method: 'GET',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/service/api.js